/**
 * Normalizes a phone number string to (XXX) XXX-XXXX format.
 * Strips all non-digit characters, removes leading country code "1",
 * and formats the remaining 10 digits.
 */
const normalizePhone = (phone: string): string => {
    const digits = phone.replace(/\D/g, "");
    const normalized = digits.length === 11 && digits[0] === "1"
        ? digits.slice(1)
        : digits;

    if (normalized.length !== 10) {
        return phone;
    }

    return `(${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6)}`;
};

export default normalizePhone;
